import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "playVideo",
  "use": "playVideo-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"playVideo\"><g data-name=\"icon - video player - 64px\" transform=\"translate(-86.46 -86.46)\"><circle cx=\"20\" cy=\"20\" r=\"20\" transform=\"translate(86.46 86.46)\" fill=\"#031425\" /><path data-name=\"↳color\" d=\"M103.158 99.945v13.031l10.45-6.515z\" fill=\"#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol